export interface IIIFSizeParam {
  w?: number
  h?: number
}

export interface IIIFTrimParam {
  x?: number
  y?: number
  w?: number
  h?: number
}

export interface ViewerInfo {
  type: 'INFO' | 'MANIFEST' | 'DIRECT'
  url?: string
  urls?: string[]
  thumbnails?: string[]
  firstPage?: string
}

export const useIIIF = () => {
  function toSizeStr(p: IIIFSizeParam) {
    if (!p) return 'full'
    if (p.w != null && p.w > 0) {
      if (p.h != null && p.h > 0) {
        return `${p.w},${p.h}`
      } else {
        return `${p.w},`
      }
    } else {
      if (p.h != null && p.h > 0) {
        return `,${p.h}`
      } else {
        return 'full'
      }
    }
  }

  function toTrimStr(p: IIIFTrimParam) {
    if (p == null) return 'full'
    if (
      p.x != null &&
      p.y != null &&
      p.w != null &&
      p.h != null &&
      Math.floor(p.w) > 0 &&
      Math.floor(p.h) > 0
    )
      return `${Math.floor(p.x)},${Math.floor(p.y)},${Math.floor(
        p.w,
      )},${Math.floor(p.h)}`
    return 'full'
  }

  function iiifImageUrlFromInfo(
    infoJsonUrl: string,
    trim?: IIIFTrimParam,
    size?: IIIFSizeParam,
  ) {
    if (!infoJsonUrl) return null
    if (!infoJsonUrl.endsWith('.json')) return infoJsonUrl
    return (
      infoJsonUrl.replace('info.json', '') +
      `${toTrimStr(trim)}/${toSizeStr(size)}/0/default.jpg`
    )
  }

  const { fetchGetWithoutCustomHeader } = useCustomFetch()

  function getInfoJson(infoJsonUrl: string): Promise<IIIFInfo> {
    return fetchGetWithoutCustomHeader<IIIFInfo>(infoJsonUrl)
  }

  function getManfesto(manifestUrl: string): Promise<IIIFManifest> {
    return fetchGetWithoutCustomHeader<IIIFManifest>(manifestUrl)
  }

  return {
    toSizeStr,
    toTrimStr,
    getInfoJson,
    getManfesto,
    iiifImageUrlFromInfo,
  }
}
